import React, { useEffect, useState } from 'react'
import { reviewApi } from '../lib/reviewApi'
import { useAuth } from '../lib/AuthContext'
import { useReviewRequest } from '../lib/useReviewRequest'
import { REVIEW_PERMISSION_COPY, REVIEW_WORDING_VERSION } from '../lib/reviewRequests.mjs'
import './ReviewRequests.css'

export default function ReviewPermission({ workshopId, customerId }) {
  const { user, profile } = useAuth()
  if (!user?.id || profile?.id !== user.id || !['owner', 'technician'].includes(profile?.role) || profile?.workshop_id !== workshopId) return null
  return <ReviewPermissionForm key={`${user.id}:${profile.role}:${workshopId}:${customerId}`} workshopId={workshopId} customerId={customerId} />
}

function ReviewPermissionForm({ workshopId, customerId }) {
  const requestTicket = useReviewRequest()
  const [saved, setSaved] = useState(null)
  const [choice, setChoice] = useState('')
  const [attested, setAttested] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => {
    const current = requestTicket()
    setSaved(null); setChoice(''); setAttested(false); setBusy(false); setError('')
    reviewApi(workshopId, 'permission_read', { customer_id: customerId }).then(data => { if (current()) setSaved(data) }).catch(e => { if (current()) setError(e.message) })
  }, [workshopId, customerId, requestTicket])
  async function save() {
    const current = requestTicket()
    setBusy(true); setError('')
    try {
      const data = await reviewApi(workshopId, 'permission_write', { customer_id: customerId, state: choice, attested, wording_version: REVIEW_WORDING_VERSION })
      if (!current()) return
      setSaved(data); setChoice(''); setAttested(false)
    } catch (e) { if (current()) setError(e.message) }
    finally { if (current()) setBusy(false) }
  }
  return <details className="review-permission"><summary>Optional Google review emails</summary>
    <p role="status">Saved choice: {saved?.state.replace('_', ' ') || 'Loading…'}{saved?.state === 'opted_in' && !saved.eligible ? ' — email changed; not eligible' : ''}</p>
    <p>Read this choice to the customer. Leave it unanswered unless they choose. This is separate from promotions and essential service emails.</p>
    <blockquote>{REVIEW_PERMISSION_COPY}</blockquote>
    {error && <p role="alert" className="review-error">{error}</p>}
    {saved && <><label htmlFor={`review-choice-${customerId}`}>Customer’s explicit choice</label>
      <select id={`review-choice-${customerId}`} value={choice} onChange={e => { setChoice(e.target.value); setAttested(false) }}>
        <option value="">No new choice recorded</option>{saved.state !== 'revoked' && <option value="opted_in">Yes, optional review emails</option>}
        {saved.state !== 'revoked' && <option value="declined">No, thank you</option>}<option value="revoked">Stop review invitations</option>
      </select>
      <label className="review-choice"><input type="checkbox" checked={attested} onChange={e => setAttested(e.target.checked)} /> I confirm the customer made this choice after hearing the wording above.</label>
      <p className="text-muted fs12">This records permission for the currently saved email. Save an email change first. Service can continue without answering.</p>
      {saved.state === 'revoked' && <p>Review invitations are stopped. Staff cannot re-subscribe a customer here.</p>}
      <button type="button" className="btn btn-secondary" disabled={!choice || !attested || busy} onClick={save}>{busy ? 'Recording…' : 'Record review preference'}</button>
    </>}
  </details>
}
